// ── Assessor BPP-exempt signal ───────────────────────────────────────────────
// An assessor's Business Personal Property track is "exempt" when the literal text "Exempt" sits in any
// of these three fields. This is the ONLY exempt mechanism for assessors — text-based, BPP-only (RE is
// never exempt for a taxing assessor). The importer produces it by passing the source sheet's "Exempt"
// cells through as text; the Add/Edit modal produces it by writing "Exempt" here when the box is ticked.
//
// MUST stay shared: the detail/list READ this to render "Exempt", the modal WRITES it. If the two used
// different field sets, ticking the box wouldn't show "Exempt" (or vice-versa). One definition, no drift.
export const EXEMPT_TEXT = 'Exempt';
export const BPP_EXEMPT_FIELDS = ['pp_assessment_date', 'pp_reappraisal_cycle', 'pp_fiscal_year'];

// The other pp_* fields, blanked when a track is exempt (they carry no meaning without an assessment).
export const BPP_OTHER_FIELDS = ['pp_reappraisal_year', 'pp_ratio', 'pp_compliance_season',
  'pp_extensions', 'pp_notice_season', 'pp_appeal_season'];

// True when the assessor row reads exempt on its BPP track.
export const isBppExempt = (a) => BPP_EXEMPT_FIELDS
  .some(k => String(a?.[k] || '').trim().toLowerCase() === EXEMPT_TEXT.toLowerCase());
